/*
  Status badges (snippets/fw-badges.liquid).
  1. Removes Pre-order and New badges whose data-fw-until time has passed, so a cached page
     never shows an expired badge. Runs on load and when new cards arrive (filters, search, quick add).
  2. Product page: after a variant change, copies the badge stack from the section HTML Dawn
     fetched (assets/product-info.js), so Sale follows the selected variant.
*/
(() => {
  const removeExpired = (root) => {
    const now = Date.now() / 1000;
    root.querySelectorAll('.fw-badge[data-fw-until]').forEach((badge) => {
      if (Number(badge.dataset.fwUntil) <= now) badge.remove();
    });
  };

  const init = () => {
    removeExpired(document);
    new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (node.nodeType === 1) removeExpired(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (!data || !data.html) return;
        const id = `FwBadges-${data.sectionId}`;
        const source = data.html.getElementById(id);
        const target = document.getElementById(id);
        if (source && target) {
          target.innerHTML = source.innerHTML;
          removeExpired(target);
        }
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
